import { BillingService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { QueryFunctionContext } from '@tanstack/react-query';
import type { TCall } from '../types/TCall';
import type { billingKeys } from './billingKeys';

type TParams = QueryFunctionContext<ReturnType<typeof billingKeys.jobPricing>>;

export const createFetchJobPricingQueryFn =
  (call: TCall) =>
  ({ queryKey: [{ jobId, enhanced }], signal }: TParams) =>
    enhanced
      ? call(() => cancelOnSignal(BillingService.calculateJobEnhancementPricing({ jobId }), signal))
      : call(() => cancelOnSignal(BillingService.calculateJobPricing({ jobId }), signal));
